const translations = {
  fr: {
    commonSales: {
      description: 'Description',
      opportunities: 'Occasions',
      oppPerWeek: 'Occ. / sem.',
      costPerOpp: 'Coût / Occ.',
      totalReachPerWeek: 'Portée / sem',
      averageFrequencyPerWeek: 'Fréquence moyenne / sem',
      impressionsPerWeek: 'Impressions / sem',
      notes: 'Notes internes',
      propositionInformationMessage: 'Ceci est une prévision basée sur une moyenne de l\'écoute des semaines complètes entre le {{from, LL}} et le {{to, LL}}',
      proposedOnDate: 'Proposée le: {{date, LL}}',
      campaignDateDisplay: 'Campagne du {{from, LL}} au {{to, LL}}',
      propositions: 'Propositions',
      send: 'Envoyer',
      campaignProposedOn: 'Campagne proposée le: {{date, LL}}',
      avgFreq: 'Fréq. moy',
      totalSummary: 'Total',
      sampling: {
        total: 'Échantillonnage total : ',
        listening: 'Échantillon : ',
        totalTooltip: 'l\'échantillonnage total est provincial',
      },
      all: 'Toutes les propositions',
      none: 'Aucune proposition',
      draft: 'Brouillon',
      proposed: 'Envoyée',
      accepted: 'Acceptée',
      cancelled: 'Annulée/Refusée',
      noRightsForPropositionOrNotFound: 'Vous n\'avez pas le droit d\'accéder à cette proposition ou elle n\'existe pas.',
      spotsSold: 'Spot vendu',
      spotsSold_plural: 'Spots vendus',
      spotsBought: 'Spot acheté',
      spotsBought_plural: 'Spots achetés',
      simpleDateRange: '{{from, DD MMMM YYYY}} au {{to, DD MMMM YYYY}}',
      simpleTimeRange: '{{from, HH:mm}} à {{to, HH:mm}}',
      couldNotLoadSaleProposal: 'Une erreur est survenue lors du chargement de la proposition',
    },
  },
  en: {
    commonSales: {
      description: 'Description',
      opportunities: 'Opportunities',
      oppPerWeek: 'Spots / Week',
      costPerOpp: 'Cost / Spot',
      totalReachPerWeek: 'Reach / Week',
      averageFrequencyPerWeek: 'Average Frequency / Week',
      impressionsPerWeek: 'Impressions / Week',
      notes: 'Internal notes',
      propositionInformationMessage: 'This is a forecast based on the listening average of the full weeks between {{from, LL}} and {{to, LL}}',
      proposedOnDate: 'Proposed on: {{date, LL}}',
      campaignDateDisplay: 'Campaign from {{from, LL}} to {{to, LL}}',
      propositions: 'Proposals',
      campaignProposedOn: 'Campaign proposed on: {{date, LL}}',
      avgFreq: 'Avg freq.',
      totalSummary: 'Total',
      sampling: {
        total: 'Total Sampling: ',
        listening: 'Sample: ',
        totalTooltip: 'the total sampling is provincial',
      },
      all: 'All proposals',
      none: 'No proposal',
      draft: 'Drafted',
      proposed: 'Sent',
      accepted: 'Accepted',
      cancelled: 'Refused/Cancelled',
      noRightsForPropositionOrNotFound: 'You can\'t access this proposal or it doesn\'t exist.',
      spotsSold: 'Spot sold',
      spotsSold_plural: 'Spots sold',
      spotsBought: 'Spot Bought',
      spotsBought_plural: 'Spots Bought',
      simpleDateRange: '{{from, MMMM DD, YYYY}} to {{to, MMMM DD, YYYY}}',
      simpleTimeRange: '{{from, HH:mm}} to {{to, HH:mm}}',
      couldNotLoadSaleProposal: 'Could not load sale proposal',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/common/modules/sales/i18n/commonSales.js